import React from "react";
function OctaFXMT4WebTerminal() {
  const url =
    "https://trade.mql5.com/trade?servers=OctaFX-Real,OctaFX-Real2,OctaFX-Real3,OctaFX-Real4,OctaFX-Real5,OctaFX-Real6,OctaFX-Real7,OctaFX-Demo,OctaFX-Demo2&lang=en&platform=MetaTrader4";
  return (
    <iframe
      src={url}
      title="OctaFX MT4 Web Terminal"
      width="100%"
      height="600px"
      style={{ border: 0, borderRadius: 8, minHeight: 400 }}
      allowFullScreen
    />
  );
}
export default OctaFXMT4WebTerminal;  // <-- THIS LINE IS NEEDED


